<template>
	<div class="tag-buttons">
		<slot name="header" />
		<div
			class="tag-buttons__button-w"
			:class="[`-${alignButtons}`]"
		>
			<TagButton
				v-for="tag in tags"
				:key="generateLoopKey(tag.key)"
				:class="{ '-highlight': tag.highlight }"
				:label="transTagLabel(tag.label, sportName, tag.type)"
				:icon-name="`tag-${tag.label}`"
				:is-squared="squaredButtons"
				@click="tagClicked(tag)"
			/>
		</div>
	</div>
</template>

<script>
import TagButton from '@videotools/js/one/components/TagButton/TagButton';

export default {
	name:       'TagButtons',
	components: { TagButton },
	props:      {
		tags: {
			type:    Array,
			default: () => [],
		},
		sportName: {
			type:    String,
			default: null,
		},
		squaredButtons: {
			type:    Boolean,
			default: false,
		},
		alignButtons: {
			type:      String,
			default:   'two-columns',
			validator: (v) => (['one-column', 'two-columns', 'rows'].includes(v)),
		},
	},
	computed: {
		participantLogo() {
			if (!this.team?.imageUrl) {
				return null;
			}
			return this.$Helpers.getScaledImageUrl(this.team.imageUrl, 50);
		},
	},
	methods: {
		tagClicked(tag) {
			this.$emit('tag-click', tag);
		},
		generateLoopKey(...keyParts) {
			const parts = keyParts
				.filter(part => part)
				.map(part => `-${part}`);

			return 'tag-button'.concat(...parts);
		},
	},
};

</script>

<style lang="scss" scoped>
.tag-buttons {
	width: 100%;
}

.tag-buttons__button-w {
	width: 100%;

	&.-one-column {
		display: flex;
		flex-direction: column;
		gap: 15px;
	}

	&.-two-columns {
		display: flex;
		flex-wrap: wrap;
		gap: 16px;

		:nth-child(2n) {
			justify-self: end;
		}
	}

	&.-rows {
		display: flex;
		flex-wrap: wrap;
		gap: 15px;
	}
}
</style>
